import { Station } from 'dataSources/Typicode/stations';
import { IconButton, Tooltip } from 'e100-react-components';
import { useStationsOperations } from 'entities/stations';
import React from 'react';
import { useIntl } from 'react-intl';

export const DeleteSelectedStationButton = ({ station }: DeleteSelectedStationButtonProps) => {
  const { formatMessage } = useIntl();
  const { removeSelectedStationOnRoute } = useStationsOperations();

  const onDeleteHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    removeSelectedStationOnRoute(station.code);
  };

  return (
    <Tooltip title={formatMessage({ id: 'removeStationOnRoute' })} placement="top">
      <IconButton kind="delete" color="secondary" onClick={onDeleteHandler} />
    </Tooltip>
  );
};

interface DeleteSelectedStationButtonProps {
  station: Station;
}
